// extracted by mini-css-extract-plugin
module.exports = {"msnbcDailyHeader":"msnbcDailyHeader___2SuFg","inner":"inner___3uDum","title":"title___26Yad","description":"description___1864R"};